import React, { CSSProperties } from "react"
import { useOperator } from "hooks"
import { isNotEmpty, importView } from "utils"

interface LogoProps {
	className?: string
	style?: CSSProperties
	color?: string
	width?: string
	height?: string
}

export const Logo: React.FC<LogoProps> = ({ className, style, color, width, height }) => {
	const { currentOperator, isOperatorComplete } = useOperator()
	const [view, setView] = React.useState(null)

	React.useEffect(() => {
		if (isOperatorComplete && !isNotEmpty(view)) {
			const loadView = async () => {
				const componentPromises: any = [currentOperator].map((operator) => {
					const LogoView = importView(
						operator,
						"Logo"
					) as unknown as React.ComponentType<LogoProps>

					return (
						<LogoView
							className={className}
							style={style}
							color={color}
							width={width}
							height={height}
							key={operator.id}
						/>
					)
				})
				await Promise.all(componentPromises).then(setView).catch(console.error)
			}
			loadView()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return <React.Suspense fallback="Loading logo...">{view}</React.Suspense>
}
